// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk-actions-remove-from-connect-modal .cu-alert {
  margin-bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./app/bulk-actions/bulk-actions-remove-from-connect-modal/bulk-actions-remove-from-connect-modal.less"],"names":[],"mappings":"AAAA;EAEQ,kBAAA;AAAR","sourcesContent":[".bulk-actions-remove-from-connect-modal {\n    .cu-alert {\n        margin-bottom: 0px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
